import { useEffect, useState } from 'react';
import styles from './favorite.module.scss';
import { IconButton } from '@mui/material';
import { FavoriteSharedProps } from '../../interfaces/components';
import { useToast } from "../../helpers/hooks";
import { Skeleton } from '@mui/material';
import { images } from '../../constants/images';
import { AnalyticsService } from '../../helpers/analytics';
import { useAuthModal } from '../../context/AuthModalContext';

const FavoriteShared = ({
    onPress,
    id, 
    publication,
    liked = false,
    className,
    user,
    likedFetching,
    likePublication,
    dislikePublication,
    loading = false,
    redirect = "",
    setLoginRedirection,
    withText = false,
    color = "black",
    size = "normal"
}: FavoriteSharedProps) => {
    const toast = useToast();
    const { handleOpenAuthModal } = useAuthModal();
    const [localLiked, setLocalLiked] = useState<boolean>(liked);

    const handleChangeFavorite = async (event: any, idItem: string) => {
        event.preventDefault();
        if (!user) {
            toast("Debes iniciar sesión para guardar favoritos");
            handleOpenAuthModal();
            return;
        };

        if(likedFetching === "loading"){
            return;
        }

        setLocalLiked(!localLiked);

        if (localLiked) {
            dislikePublication(idItem);
        } else {
            likePublication(idItem);
            AnalyticsService.trackAddToWishlist(idItem);
        }

        if(onPress) onPress(event);
    }

    useEffect(() => {
        setLocalLiked(liked);
    }, [liked]);
    
    useEffect(() => {
        if(likedFetching === 'failure'){
            toast("Ha ocurrido un error");
            setLocalLiked(!localLiked); // Revert on failure
        }
    }, [likedFetching]);

    return (
        <>
        {
            loading
            ? <Skeleton animation="wave" variant="circular" className={styles.skeleton} />
            : 
            <div className={`${styles.favorite} ${color === "black" ? styles.black : styles.blue} ${size === "small" && styles.small}`} onClick={(event: any) => handleChangeFavorite(event, id)}>
                <IconButton id="icon" className={className}>
                    <img src={localLiked ? images.favorite : images.noFavorite} alt="Me gusta" title="Me gusta" id="iconFavorite" className={styles.icon} />
                </IconButton>
                {
                    withText &&
                    <p className={styles.text}>Favoritos</p>
                }
            </div>
        }
        </>
    );
};

export default FavoriteShared;